import React, { CSSProperties, ReactNode } from 'react';
import AntdSteps from 'antd/lib/steps';
import { childrenOfType } from '../../../utils';
import classnames from 'classnames';

/**
 * {@docCategory Steps}
 */
export interface StepsProps {
   /**
    * To set the current step, counting from 0. You can overwrite this state by using status of Step.
    * @defaultvalue 0
    */
   currentStep?: number;

   /**
    * To specify the status of current step, can be set to one of the following values: wait process finish error.
    * @defaultvalue process
    */
   status?: 'wait' | 'process' | 'finish' | 'error';

   /**
    * To specify the direction of the step bar, horizontal or vertical
    * @defaultvalue horizontal
    */
   direction?: 'horizontal' | 'vertical';

   /**
    * Place title and description with horizontal or vertical direction
    * @defaultvalue horizontal
    */
   labelPlacement?: 'horizontal' | 'vertical';

   /**
    * To specify the size of the step bar, default and small are currently supported.
    * @defaultvalue default
    */
   size?: 'default' | 'small';

   /**
    * Type of steps, can be set to one of the following values: default, navigation.
    * @defaultvalue default
    */
   type?: 'default' | 'navigation';

   /**
    * Steps with progress dot style. labelPlacement will be vertical
    * @defaultvalue false
    */
   progressDot?: boolean;

   /**
    * Trigger when Step is changed.
    * @param currentStep - The current step
    */
   onChange?: (currentStep: number) => void;

   /**
    * Sets a className.
    */
   className?: string;

   /**
    * Sets styles.
    */
   style?: CSSProperties;

   /**
    * The steps.
    */
   children?: ReactNode;
}

/**
 * {@docCategory Steps}
 */
export interface StepProps {
   /**
    * Title of the step
    */
   title?: ReactNode;

   /**
    * Subtitle of the step
    */
   subTitle?: ReactNode;

   /**
    * Description of the step.
    */
   description?: ReactNode;

   /**
    * Icon of the step.
    */
   icon?: ReactNode;

   /**
    * To specify the status of current step, can be set to one of the following values: wait process finish error.
    * @defaultvalue wait
    */
   status?: 'wait' | 'process' | 'finish' | 'error';

   /**
    * Set disabled.
    * @defaultvalue false
    */
   disabled?: boolean;
}

export const Steps = (props: StepsProps) => {
   const className = classnames('uf-steps', props.className);

   return (
      <AntdSteps
         current={props.currentStep}
         direction={props.direction}
         labelPlacement={props.labelPlacement}
         size={props.size}
         status={props.status}
         type={props.type}
         progressDot={props.progressDot}
         onChange={props.onChange}
         className={className}
         style={props.style}
      >
         {mapChildren(props)}
      </AntdSteps>
   );
};

export class Step extends React.Component<StepProps> {
}

const mapChildren = (props: StepsProps) => {
   return childrenOfType(props.children, Step).map(((value, index) => {
      const stepProps = value.props as StepProps;

      return (
         <AntdSteps.Step
            key={index}
            title={stepProps.title}
            subTitle={stepProps.subTitle}
            description={stepProps.description}
            icon={stepProps.icon}
            status={stepProps.status}
            disabled={stepProps.disabled}
         />
      );
   }));
};
